import { Grid, Typography, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { appIcons } from "../../../assets";
import DashboardCard from "../../../components/cards/DashboardCard";
import CustomContainer from "../../../components/container/CustomContainer";
import DashboardHeader from "../../../components/dashboardHeader";
import { socketUrl } from "../../../services";
import CustomerSupportDialog from "./CustomerSupportDIalog";
import { getUserDetailById } from "../../../services/userDetailFn";
import { useSelector, useDispatch } from "react-redux";
import { CURRENCY } from "../../../lib/variables";
import { setUserData } from "../../../lib/redux/slices/userSlice";
import AppLoader from "../../../components/apploader";
// const socket = io.connect("http://localhost:5000");
import io from "socket.io-client";
import useNotifications from "../../../hooks/useNotifications";
import GlobalButton from "../../../components/button";
import { t } from "i18next";
const socket = io.connect(socketUrl);

const cardData = [
  // {
  //   title: "Track Your Children",
  //   icon: appIcons.purpleEdIcon,
  //   path: "education",
  // },
  {
    title: "eCom",
    icon: appIcons.purpleCartIcon,
    path: "e-commerce",
  },
  {
    title: "services",
    icon: appIcons.purpleServiceIcon,
    path: "service",
  },
  {
    title: "profileDetails",
    icon: appIcons.purpleUserIcon,
    path: "setting",
  },
  {
    title: "notification",
    icon: appIcons.purpleNotification1Icon,
    path: "notification",
  },
  {
    title: "customerSupport",
    icon: appIcons.purpleCustomerSupportIcon,
    path: "customer-support",
  },
  {
    title: "addressBook",
    icon: appIcons.purpleFeesIcon,
    path: "address-book",
  },
  {
    title: "walletHistory",
    icon: appIcons.purpleFeesIcon,
    path: "wallet-history",
  },
  {
    title: "ecommercePackage",
    icon: appIcons.purpleFeesIcon,
    path: "ecommerce-package",
  },
  {
    title: "withdrawRequest",
    icon: appIcons.purpleFeesIcon,
    path: "withdraw-request",
  },
];

const UserDashboardPage = () => {
  const openSupportDialog = useRef(null);
  const { markUserNotificationRead } = useNotifications();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const userData = useSelector((state) => state.userReducer.user);

  const handleClickOnCard = (row, index) => {
    if (row.path == "notification") {
      markUserNotificationRead();
      navigate(`/dashboard/${row.path}`);
    } else if (row.path !== "customer-support") {
      navigate(`/dashboard/${row.path}`);
    } else {
      openSupportDialog.current.openDialog();
    }
  };

  const getDetail = async () => {
    try {
      setIsLoading(true);
      let ressss = await getUserDetailById(userData._id);
      if (ressss.data.status === true) {
        setUserDetails(ressss.data.data);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  const renderHeadProps = () => {
    return (
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={"center"}
        spacing={2}
      >
        <Typography
          sx={{
            color: "#7922d8",
            fontWeight: "700",
            fontSize: "20px",
            textTransform: "capitalize",
          }}
        >
          {t("walletAmount")}: {CURRENCY} {userDetails?.wallet?.toFixed(2)}
        </Typography>
      </Stack>
    );
  };

  return (
    <DashboardHeader>
      <AppLoader isVisible={isLoading} />
      <CustomContainer
        paperSxProps={{
          minHeight: "80vh",
        }}
        primaryHeading={t("dashboard")}
        secondaryHeading={t("youHaveAccess")}
        headProps={renderHeadProps()}
      >
        <Typography variant="h6" mb={3} textTransform={"capitalize"}>
          {t("allAccessPoints")}{" "}
        </Typography>

        <Grid container rowSpacing={2} columnSpacing={2}>
          {cardData?.map((val, index) => {
            return (
              <Grid key={index} item xs={12} sm={4} md={3}>
                <DashboardCard
                  data={val}
                  index={index}
                  handleClickOnCard={handleClickOnCard}
                />
              </Grid>
            );
          })}
        </Grid>
      </CustomContainer>
      <CustomerSupportDialog
        ref={openSupportDialog}
        socket={socket}
        handleConfirm={() => openSupportDialog.current.closeDialog()}
      />
    </DashboardHeader>
  );
};

export default UserDashboardPage;
